module.exports = __webpack_public_path__ + "media/images/application/template/icon--modular-tool-5fe5b07e468f0592cc36c55dc5aef307.svg";